import { FC } from "react";
import { CustomButton } from "../../CustomButton/CustomButton";
import { CallIcon } from "../../icons/CallIcon";
import { ModalComponent } from "../UiModals";

interface IProps {
    onSuccess: () => void;
    userName: string;
    isIncomming: boolean;
}

interface IPropsActions extends IProps {
    close: () => void;
}

const Modal: FC<IPropsActions> = ({
                                      close,
                                      onSuccess,
                                      userName,
                                      isIncomming
                                  }) => {

    return (
        <div className="communication-modal-content communication-modal-content_call" style={{width: 300}}>
           <div className={"incoming-call-body"}>
               <div className={"incoming-call-icon"}><CallIcon /></div>
               <div className={"incoming-call-content"}>
                   <div>{isIncomming ? 'Входящий' : 'Исходящий'} звонок</div>
                   <div className={"incoming-call-content__name"}>{userName}</div>
               </div>
           </div>
            <div style={{display: 'flex', gap: 8, marginTop: 8}}>
                {isIncomming && <CustomButton className={"communication-button_call"} onClick={() => onSuccess()}>Принять</CustomButton>}
                <CustomButton className={"communication-button_call"} isCancel={true} onClick={() => close()}>Отклонить</CustomButton>
            </div>
        </div>
    );
};

export const IncommingCall = (props: IProps): ModalComponent => {
    return ({close}) => {
        return <Modal close={close} {...props} />;
    };
};
